<h1 mat-dialog-title>
  Background Color
</h1>
    
<div class="background theme-light">

  <app-tabs (activeTabChange)="handleTabChange($event)">

    <!-- presets -->
    <app-tab label="Presets" #presetTab>

      <div class="background__section mt-3">
        
        <!-- preset swatch -->
        <app-form-field>
        
          <div class="background__swatches">

              <app-swatch-item            
                *ngFor="let background of presetBackgrounds"
                class="m-1"
                [color]="background"
                [size]="'medium'"
                [selected]="backgroundsEqual(background, presetBackground)"           
                (click)="handlePresetSelected(background)">
              </app-swatch-item>

          </div>

        </app-form-field>

        <!-- chapter default -->
        <button
          app-button
          buttonType="outline"
          buttonTheme="light"
          buttonSize="small" 
          class="mb-4" (click)="handleResetClick()">
            Revert to Original
        </button>

        <!-- chapters swatch -->
        <app-form-field label="Currently Used">

          <div class="background__swatches">

              <app-swatch-item
                *ngFor="let background of distinctBackgrounds"
                class="m-1"
                [color]="background"
                [size]="'medium'"
                (click)="handlePresetSelected(background)">
              </app-swatch-item>

          </div>

        </app-form-field>
      </div>
      

    </app-tab>

    <!-- custom -->
    <app-tab label="Custom" #customTab>

      <form
        class="background__section mt-4"
        [formGroup]="form"
        [ngSwitch]="form.get('type').value">

          <!-- color type -->
          <app-form-field label="Type">

            <select class="input" formControlName="type">
              <option value="solid">Solid Color</option>
              <option value="radial">Radial Gradient</option>
              <option value="linear">Linear Gradient</option>
              <option value="transparent">Transparent</option>        
            </select>

          </app-form-field>
          
          <!-- solid config -->
          <div *ngSwitchCase="'solid'">

              <app-form-field label="Color">
                  <input
                    class="input"
                    type="text"
                    [colorPicker]="getFormBackgroundHex('color1')"
                    (colorPickerChange)="handleFormColorSelected('color1', $event)" 
                    [cpOutputFormat]="'hex'"
                    [cpAlphaChannel]="'disabled'"
                    [style.background]="getFormBackgroundHex('color1')"
                    cpPosition="left">
              </app-form-field>

          </div>

          <!-- radial config -->
          <div *ngSwitchCase="'radial'">

              <app-form-field label="Inner Color">
                  <input
                    class="input"
                    type="text"
                    [colorPicker]="getFormBackgroundHex('color1')"
                    (colorPickerChange)="handleFormColorSelected('color1', $event)" 
                    [cpOutputFormat]="'hex'"
                    [cpAlphaChannel]="'disabled'"
                    [style.background]="getFormBackgroundHex('color1')"
                    cpPosition="left">
              </app-form-field>

              <app-form-field label="Inner Radius">
                  <app-slider theme="light" [min]="0" [max]="100" formControlName="stop1"></app-slider>
              </app-form-field>
  
              <app-form-field label="Outer Color">
                  <input
                    class="input"
                    type="text"
                    [colorPicker]="getFormBackgroundHex('color2')"
                    (colorPickerChange)="handleFormColorSelected('color2', $event)" 
                    [cpOutputFormat]="'hex'"
                    [cpAlphaChannel]="'disabled'"
                    [style.background]="getFormBackgroundHex('color2')"
                    cpPosition="left">
              </app-form-field>

              <app-form-field label="Outer Radius">
                  <app-slider theme="light" [min]="0" [max]="100" formControlName="stop2"></app-slider>
              </app-form-field>
  
          </div>

          <!-- linear config -->
          <div *ngSwitchCase="'linear'">

            <app-form-field label="Starting Color">
                <input
                  class="input"
                  type="text"
                  [colorPicker]="getFormBackgroundHex('color1')"
                  (colorPickerChange)="handleFormColorSelected('color1', $event)" 
                  [cpOutputFormat]="'hex'"
                  [cpAlphaChannel]="'disabled'"
                  [style.background]="getFormBackgroundHex('color1')"
                  cpPosition="left">
            </app-form-field>

            <app-form-field label="Starting Color Stop">
              <app-slider theme="light" [min]="0" [max]="100" formControlName="stop1"></app-slider>
            </app-form-field>

            <app-form-field label="Ending Color">
                <input
                  class="input"
                  type="text"
                  [colorPicker]="getFormBackgroundHex('color2')"
                  (colorPickerChange)="handleFormColorSelected('color2', $event)" 
                  [cpOutputFormat]="'hex'"
                  [cpAlphaChannel]="'disabled'"
                  [style.background]="getFormBackgroundHex('color2')"
                  cpPosition="left">
            </app-form-field>
            
            <app-form-field label="Ending Color Stop">
                <app-slider theme="light" [min]="0" [max]="100" formControlName="stop2"></app-slider>
            </app-form-field>

          </div>

          <!-- transparent conifg -->
          <div *ngSwitchCase="'transparent'">
            <app-alert type="info" theme="light">
              The background of your application will appear behind the 3D model.
            </app-alert>
          </div>

      </form>
     
    </app-tab>

  </app-tabs>

</div>

<div mat-dialog-actions>
  <button app-button buttonTheme="light" class="mr-2" (click)="applyAll()">Apply to All</button>
  <button app-button buttonType="flat" buttonTheme="light" [mat-dialog-close]="true" cdkFocusInitial>Done</button>
</div>